export default __webpack_public_path__ + "static/media/WinterSale_Backpacks_900x525.690674bb.jpg";